import { render } from "./DepositMethodButton.vue?vue&type=template&id=11904d19&scoped=true"
import script from "./DepositMethodButton.vue?vue&type=script&lang=js"
export * from "./DepositMethodButton.vue?vue&type=script&lang=js"

import "./DepositMethodButton.vue?vue&type=style&index=0&id=11904d19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11904d19"]])

export default __exports__